import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomePersonalFeed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-personal-feed, for-you"><path d="M3.75 9V20.25H20.25V9L12 3.75L3.75 9Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M16.25 20C16.25 17.6528 14.3472 15.75 12 15.75C9.65279 15.75 7.75 17.6528 7.75 20" stroke="currentColor" strokeWidth="1.5"/><path d="M14.25 11.5C14.25 12.7426 13.2426 13.75 12 13.75C10.7574 13.75 9.75 12.7426 9.75 11.5C9.75 10.2574 10.7574 9.25 12 9.25C13.2426 9.25 14.25 10.2574 14.25 11.5Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconHomePersonalFeed;
